import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, styled } from '@mui/material';

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    height: '6px',
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: '600',
  opacity: 0.7,
  color: theme.palette.primary.main,
  '&.Mui-selected': {
    opacity: 1,
  },
}));

const styles = {
  root: {
    backgroundColor: '#fff',
    backdropFilter: 'blur(8px)',
  },
}

export default function AmploTabs({ tabs, onChange }) {
  
  const [index, setIndex] = useState(0);

  const handleChange = (event, newValue) => {
    setIndex(newValue);
    onChange(newValue);
  };

  return (
    <div style={styles.root}>
      <StyledTabs
        value={index}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="secondary"
      >
        {tabs.map((t) => (
          <StyledTab key={t} label={t} />
        ))}
      </StyledTabs>
    </div>
  );
}

AmploTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func,
};
